import { Component, Input } from '@angular/core';
import { PageService } from '../../services/Page/page.service';
import { TopSliderComponent } from "../top-slider/top-slider.component";
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { gsap, Expo, Quad } from 'gsap';
import { SearchInputComponent } from "../search-input/search-input.component";
import { PosterListComponent } from "../poster-list/poster-list.component";
import { FeaturedListComponent } from "../featured-list/featured-list.component";
import { SearchService } from '../../services/Search/search.service';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { SquareListComponent } from "../square-list/square-list.component";
import { LargeImageComponent } from "../large-image/large-image.component";



@Component({
    selector: 'app-home-page',
    imports: [
        TopSliderComponent,
        SearchInputComponent,
        PosterListComponent,
        FeaturedListComponent,
        SquareListComponent,
        LargeImageComponent
    ],
    templateUrl: './home-page.component.html',
    styleUrl: './home-page.component.scss'
})
export class HomePageComponent {

    public isMobile: boolean = false

    constructor(
        public pageService: PageService,
        public searchService: SearchService,
        private breakpointObserver: BreakpointObserver,
        private router: Router
    ) {
        breakpointObserver.observe([
            Breakpoints.HandsetLandscape,
            Breakpoints.HandsetPortrait
        ]).subscribe(result => {
            if (result.matches) {
                this.isMobile = true;
            }
            else {
                this.isMobile = false;
            }
        });
    }

    public searchText(text: string) {
        // this.searchService.query = text
    }

    public onSearchSubmit() {
        this.router.navigate(['/search']);
    }

    public throwTestError(): void {
        throw new Error("Sentry Test Error");
    }
}
